<template>
  <div id="app">
    <router-view></router-view>
  </div>

</template>

<script>
export default {
  name: "app",
  created() {
    // //在页面加载时读取sessionStorage里的状态信息
    // if (sessionStorage.getItem("store") ) {
    //     this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
    // }
    // //在页面刷新时将vuex里的信息保存到sessionStorage里
    // window.addEventListener("beforeunload",()=>{
    //     sessionStorage.setItem("store",JSON.stringify(this.$store.state))
    // })
  },
};
window.onload = function () {
  if (!!window.ActiveXObject || "ActiveXObject" in window) {
    alert(
      "您正在使用低版本浏览器,为了保证您能有更好的访问效果,我们建议您使用谷歌Chrome浏览器、火狐Firefox浏览器!"
    );
  } else {
    // console.log("no");
  }
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};
//    function resize() {
//         var body = document.getElementsByTagName('body')[0];
//         var html = document.getElementsByTagName('html')[0];
//         var width = html.clientWidth;
//         var height =  html.clientHeight;
//         var max = width > height ? width : height;
//         var min = width > height ? height : width;
//         body.style.width = max + "px";
//         body.style.height = min + "px";
//       }
//       resize();
//       window.addEventListener("resize", resize)

// 禁用双指放大
document.documentElement.addEventListener(
  "touchstart",
  function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  },
  {
    passive: false,
  }
);

// 禁用双击放大
var lastTouchEnd = 0;
document.documentElement.addEventListener(
  "touchend",
  function (event) {
    var now = Date.now();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  },
  {
    passive: false,
  }
);
</script>

<style>
#app {
  overflow-y: auto;
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  color: #2c3e50;
  padding: 0;
  margin: 0;
  width: 100%;
  min-height: 710px;
  height: 100%;
}
</style>
